import React, { useState, useEffect } from "react";
import Overlay from "Components/Overlay";
import "./RfqTollUpdatePrice.scss";
import Input from "Components/Input";
import {
  POST_TOLL_TAX_UPDATE_PRICE,
  UPLOAD_DOCUMENT,
} from "Constants/actionConstants";
import Upload from "Components/Upload";
import { DateRangePicker } from "react-dates";
import Moment from "moment";
import Cx from "classnames";
import { getUser } from "Utils/storage";
import { useDispatch } from "react-redux";
import { MdDelete } from "react-icons/md";

const RfqTollUpdatePrice = (props) => {
  const {
    is_rfq_toll_price_update,
    is_rfq_price_update,
    rfq,
    focusedInput,
    onFocusChange,
    CTData,
    onSave,
    onCancel,
    selectedTrip,
    getSeekerBids
  } = props;

  const { contractTenureFrom, contractTenureTo } = CTData;

  const [activeTab, setActiveTab] = useState(
    is_rfq_toll_price_update ? "toll" : is_rfq_price_update ? "flat" : ""
  );
  const [activeSubTab, setActiveSubTab] = useState("percentage");


  // const [toll_file, setTollFile] = useState(null);
  // const [flat_percentage_file, setFlatPercentageFile] = useState(null);
  // const [flat_amount_file, setFlatAmountFile] = useState(null);
 
  const [toll_tax_price, setTollTaxPrice] = useState(selectedTrip[0]?.toll_tax_diff_price || "");
  const [toll_tax_denominator, setTollTaxDenominator] = useState(
    rfq?.toll_tax_denominator || ""
  );
  const [toll_tax_percentage, setTollTaxPercentage] = useState(
    rfq?.toll_tax_percentage || ""
  );
  const [toll_tax_url, setTollTaxUrl] = useState(selectedTrip[0]?.toll_tax_url || "");
  const [flat_percentage_url, setFlatPercentageUrl] = useState(selectedTrip[0]?.toll_tax_url || "");
  const [flat_amount_url, setFlatAmountUrl] = useState(selectedTrip[0]?.toll_tax_url || "");

  const [dph_from_date, setFromDate] = useState(
    selectedTrip[0]?.dph_from_date || contractTenureFrom || null
  );
  const [dph_to_date, setToDate] = useState(
    selectedTrip[0]?.dph_to_date || contractTenureTo || null
  );

  const [flat_rate_percentage, setFlatRatePercentage] = useState(
    selectedTrip[0]?.toll_tax_price || ""
  );
  const [flat_rate_amount, setFlatRateAmount] = useState(
    selectedTrip[0]?.toll_tax_price || ""
  );

  const [validationErrors, setValidationErrors] = useState(null);

  const dispatch = useDispatch();

  // ✅ Update state when rfq changes dynamically
  useEffect(() => {
    if (rfq) {
      setTollTaxPrice(selectedTrip[0]?.toll_tax_diff_price || "");
      setTollTaxDenominator(rfq?.toll_tax_denominator || "");
      setTollTaxPercentage(rfq?.toll_tax_percentage || "");
      setTollTaxUrl(selectedTrip[0]?.toll_tax_url || "");
      setFromDate(selectedTrip[0]?.dph_from_date || contractTenureFrom || null);
      setToDate(selectedTrip[0]?.dph_to_date || contractTenureTo || null);
      setFlatRatePercentage(selectedTrip[0]?.toll_tax_price || "");
      setFlatRateAmount(selectedTrip[0]?.toll_tax_price || "");
      setFlatPercentageUrl(selectedTrip[0]?.toll_tax_url || "")
      setFlatAmountUrl(selectedTrip[0]?.toll_tax_url || "")
    }
  }, []);

  // ✅ Handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "toll_tax_price":
        setTollTaxPrice(value);
        break;
      case "toll_tax_denominator":
        setTollTaxDenominator(value);
        break;
      case "toll_tax_percentage":
        setTollTaxPercentage(value);
        break;
      case "flat_rate_percentage":
        setFlatRatePercentage(value);
        break;
      case "flat_rate_amount":
        setFlatRateAmount(value);
        break;
      default:
        break;
    }
  };

  // ✅ Handle Date change
  const handleDateChange = ({ startDate, endDate }) => {
    setFromDate(startDate ? Moment(startDate).valueOf() : null);
    setToDate(endDate ? Moment(endDate).valueOf() : null);
  };

  // ✅ Upload file
  const uploadUpdateRate = (file, section) => {
    dispatch({
      type: UPLOAD_DOCUMENT,
      file,
      onSuccess: (response) => {
        if (section === "toll") {
          setTollTaxUrl(response?.url || "");

          
          setValidationErrors(prev => ({
            ...prev,
            toll_tax_url: ""
          }));
        }

        else if (section === "flat_percentage") {
          setFlatPercentageUrl(response?.url || "");

          
          setValidationErrors(prev => ({
            ...prev,
            flat_percentage_url: ""
          }));
        }

        else if (section === "flat_amount") {
          setFlatAmountUrl(response?.url || "");

          
          setValidationErrors(prev => ({
            ...prev,
            flat_amount_url: ""
          }));
        }
      },
    });
  };

  const handleRemoveUploadedFile = (section) => {
    if (section === "toll") {
      setTollTaxUrl("");
      // setTollFile(null);
    } else if (section === "flat_percentage") {
      setFlatPercentageUrl("");
      // setFlatPercentageFile(null);
    } else if (section === "flat_amount") {
      setFlatAmountUrl("");
      // setFlatAmountFile(null);
    }
  };

  const onApproveTollTax = (actionType, payload) => {

    let errors = {};

    if (payload.activeTab === "toll") {
      if (!payload.toll_tax_price) errors.toll_tax_price = "toll tax price is required";
      if (!payload.toll_tax_denominator) errors.toll_tax_denominator = "toll tax denominator is required ";
      if (!payload.toll_tax_percentage) errors.toll_tax_percentage = "toll tax percentage is required";
      if (!payload.toll_tax_url) errors.toll_tax_url = "toll tax document is required";
      if (!payload.dph_from_date) errors.dph_from_date = "toll tax from date is required";
      if (!payload.dph_to_date) errors.dph_to_date = "toll tax to date is required";
    }

    if (payload.activeTab === "flat" && payload.activeSubTab === "percentage") {
      if (!payload.flat_rate_percentage) errors.flat_rate_percentage = "flat percentage is required";
      if (!payload.flat_percentage_url) errors.flat_percentage_url = "flat document is required";
      if (!payload.dph_from_date) errors.dph_from_date = "flat from date is required";
      if (!payload.dph_to_date) errors.dph_to_date = "flat to date is required";
    }

    if (payload.activeTab === "flat" && payload.activeSubTab === "amount") {
      if (!payload.flat_rate_amount) errors.flat_rate_amount = "flat amount is required";
      if (!payload.flat_amount_url) errors.flat_amount_url = "flat document is required";
      if (!payload.dph_from_date) errors.dph_from_date = "flat from date is required";
      if (!payload.dph_to_date) errors.dph_to_date = "flat to date is required";
    }

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    // ✅ Clear errors if all fields valid
    setValidationErrors({});

    const tollUpdatedPrice =
      Math.floor(payload.toll_tax_price / payload.toll_tax_denominator) *
      payload.toll_tax_percentage;

    const user = getUser();
    const baseData = {
      rfq_id: selectedTrip[0]?.rfqId,
      company_id: selectedTrip[0]?.companyId,
      trip_id : selectedTrip[0]?.id
    };

    let requestData = {};

    if (actionType === "approve" && payload.activeTab === "toll") {
      requestData = {
        ...baseData,
        updated_price: tollUpdatedPrice,
        toll_tax_url: payload.toll_tax_url,
        toll_tax_diff_price: payload.toll_tax_price,
        dph_from_date: payload.dph_from_date,
        dph_to_date: payload.dph_to_date,
        is_approver: true,
        is_toll_tax_update_approved: true,
        toll_tax_update_approved_by: user.email,
      };
    } else if (actionType === "request" && payload.activeTab === "toll") {
      requestData = {
        ...baseData,
        updated_price: tollUpdatedPrice,
        toll_tax_diff_price: payload.toll_tax_price,
        toll_tax_url: payload.toll_tax_url,
        dph_from_date: payload.dph_from_date,
        dph_to_date: payload.dph_to_date,
        is_toll_tax_update_request: true,
        toll_tax_update_request_by: user.email,
        
      };
    } else if (
      actionType === "approve" &&
      payload.activeTab === "flat" &&
      payload.activeSubTab === "percentage"
    ) {
      requestData = {
        ...baseData,
        updated_price: payload.flat_rate_percentage ,
        toll_tax_url: payload.flat_percentage_url,
        dph_from_date: payload.dph_from_date,
        dph_to_date: payload.dph_to_date,
        is_approver: true,
        is_toll_tax_update_approved: true,
        toll_tax_update_approved_by: user.email,
        is_percentage: true 
      };
    } else if (
      actionType === "approve" &&
      payload.activeTab === "flat" &&
      payload.activeSubTab === "amount"
    ) {
      requestData = {
        ...baseData,
        updated_price: payload.flat_rate_amount ,
        toll_tax_url: payload.flat_amount_url,
        dph_from_date: payload.dph_from_date,
        dph_to_date: payload.dph_to_date,
        is_approver: true,
        is_toll_tax_update_approved: true,
        toll_tax_update_approved_by: user.email,
      };
    } else if (
      actionType === "request" &&
      payload.activeTab === "flat" &&
      payload.activeSubTab === "percentage"
    ) {
      requestData = {
        ...baseData,
        updated_price: payload.flat_rate_percentage ,
        toll_tax_url: payload.flat_percentage_url,
        dph_from_date: payload.dph_from_date,
        dph_to_date: payload.dph_to_date,
        is_toll_tax_update_request: true,
        toll_tax_update_request_by: user.email,
        is_percentage: true
      };
    } else if (
      actionType === "request" &&
      payload.activeTab === "flat" &&
      payload.activeSubTab === "amount"
    ) {
      requestData = {
        ...baseData,
        updated_price: payload.flat_rate_amount,
        toll_tax_url: payload.flat_amount_url,
        dph_from_date: payload.dph_from_date,
        dph_to_date: payload.dph_to_date,

        toll_tax_update_request_by: user.email,
        is_toll_tax_update_request: true,
      };
    }

    dispatch({
      type: POST_TOLL_TAX_UPDATE_PRICE,
      data: requestData,
      onSuccess: () => {
        // Optionally clear or refresh
        // setTollFile(null);
        // setFlatPercentageFile(null)
        // setFlatAmountFile(null)
        getSeekerBids();
      },
    });
    onCancel();
  };

  const renderFlatRateContent = () => {
    const { contractTenureFrom, contractTenureTo } = CTData;

    return (
      <div className="flat-rate-section">
        <div className="rfq-sub-tabs">
          <div
            className={`rfq-sub-tab ${
              activeSubTab === "percentage" ? "active" : ""
            }`}
            onClick={() => setActiveSubTab("percentage")}
          >
            Percentage
          </div>
          <div
            className={`rfq-sub-tab ${
              activeSubTab === "amount" ? "active" : ""
            }`}
            onClick={() => setActiveSubTab("amount")}
          >
            Amount
          </div>
        </div>

        <div className="sub-tab-body">
          {activeSubTab === "percentage" && (
            <div className="tab-content">
              <div className="toll-from-to-date">
                <label className="input-label fs-14 fSemibold mb-10">
                  From and To
                </label>
                <div className={Cx("", { "ht-400 wt-600": focusedInput })}>
                  <DateRangePicker
                    startDate={
                      dph_from_date
                        ? Moment(dph_from_date)
                        : contractTenureFrom
                        ? Moment(contractTenureFrom)
                        : null
                    }
                    startDateId="startDate"
                    endDate={
                      dph_to_date
                        ? Moment(dph_to_date)
                        : contractTenureTo
                        ? Moment(contractTenureTo)
                        : null
                    }
                    endDateId="endDate"
                    onDatesChange={handleDateChange}
                    focusedInput={focusedInput}
                    onFocusChange={onFocusChange}
                    displayFormat={"DD MMM YYYY"}
                    noBorder
                    minimumNights={0}
                    isOutsideRange={(day) => {
                      const from = Moment(contractTenureFrom);
                      const to = Moment(contractTenureTo);
                      return day.isBefore(from, "day") || day.isAfter(to, "day");
                    }}
                  />
                </div>
                {validationErrors?.dph_from_date && validationErrors?.dph_to_date &&(
                  <div className="error-text">{validationErrors.dph_from_date} {validationErrors.dph_to_date}</div>
                )}
              </div>

              <div className="upload-section mt-20">
                {flat_percentage_url ? (
                  <div className="uploaded-file-name fs-14 mt-10 flex items-center">
                    <span>File Uploaded:</span>
                    <a
                      href={flat_percentage_url}
                      target="_blank"
                      rel="noreferrer"
                      className="theme-color underline mr-10"
                    >
                      {flat_percentage_url.split("/").pop()}
                    </a>
                    <button
                      className="fs-13 text-red-600 underline no-border bg-transparent curP"
                      onClick={() => handleRemoveUploadedFile("flat_percentage")}
                    >
                      <MdDelete size={20} />
                    </button>
                  </div>
                ) : (
                    <Upload onChange={(file) => uploadUpdateRate(file, "flat_percentage")}>
                    <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-15 pr-20 mr-30">
                      Upload Toll Tax Doc
                    </button>
                  </Upload>
                )}
              </div>
              {validationErrors?.flat_percentage_url && (
                <div className="error-text">{validationErrors.flat_percentage_url}</div>
              )}

              <div className="input-group mt-20">
                <label className="input-label fs-14 fSemibold mb-5">
                  Enter Percentage
                </label>
                <Input
                  type="number"
                  placeholder="Enter Percentage"
                  name="flat_rate_percentage"
                  value={flat_rate_percentage}
                  onChange={handleInputChange}
                  // className="fs-14 no-border"
                  noTransition
                  className={Cx("fs-14 no-border", { "error-border": validationErrors?.flat_rate_percentage })}
                />
                {validationErrors?.flat_rate_percentage && (
                  <div className="error-text">{validationErrors.flat_rate_percentage}</div>
                )}
              </div>
            </div>
          )}

          {activeSubTab === "amount" && (
            <div className="tab-content">
              <div className="toll-from-to-date">
                <label className="input-label fs-14 fSemibold mb-10">
                  From and To
                </label>
                <div className={Cx("", { "ht-400 wt-600": focusedInput })}>
                  <DateRangePicker
                    startDate={
                      dph_from_date
                        ? Moment(dph_from_date)
                        : contractTenureFrom
                        ? Moment(contractTenureFrom)
                        : null
                    }
                    startDateId="startDate"
                    endDate={
                      dph_to_date
                        ? Moment(dph_to_date)
                        : contractTenureTo
                        ? Moment(contractTenureTo)
                        : null
                    }
                    endDateId="endDate"
                    onDatesChange={handleDateChange}
                    focusedInput={focusedInput}
                    onFocusChange={onFocusChange}
                    displayFormat={"DD MMM YYYY"}
                    noBorder
                    minimumNights={0}
                    isOutsideRange={(day) => {
                      const from = Moment(contractTenureFrom);
                      const to = Moment(contractTenureTo);
                      return day.isBefore(from, "day") || day.isAfter(to, "day");
                    }}
                  />
                </div>
                {validationErrors?.dph_from_date && validationErrors?.dph_to_date && (
                  <div className="error-text">{validationErrors.dph_from_date} {validationErrors.dph_to_date}</div>
                )}
              </div>

              <div className="upload-section mt-20">
                {flat_amount_url ? (
                  <div className="uploaded-file-name fs-14 mt-10 flex items-center">
                    <span>File Uploaded:</span>
                    <a
                      href={flat_amount_url}
                      target="_blank"
                      rel="noreferrer"
                      className="theme-color underline mr-10"
                    >
                      {flat_amount_url.split("/").pop()}
                    </a>
                    <button
                      className="fs-13 text-red-600 underline no-border bg-transparent curP"
                      onClick={() => handleRemoveUploadedFile("flat_amount")}
                    >
                      <MdDelete size={20} />
                    </button>
                  </div>
                ) : (
                    <Upload onChange={(file) => uploadUpdateRate(file, "flat_amount")}>
                    <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-15 pr-20 mr-30">
                      Upload Toll Tax Doc
                    </button>
                  </Upload>
                )}
              </div>
              {validationErrors?.flat_amount_url && (
                <div className="error-text">{validationErrors.flat_amount_url}</div>
              )}

              <div className="input-group mt-20">
                <label className="input-label fs-14 fSemibold mb-5">
                  Enter Amount
                </label>
                <Input
                  type="number"
                  placeholder="Enter Amount"
                  name="flat_rate_amount"
                  value={flat_rate_amount}
                  onChange={handleInputChange}
                  // className="fs-14 no-border"
                  noTransition
                  className={Cx("fs-14 no-border", { "error-border": validationErrors?.flat_rate_amount })}
                />
                {validationErrors?.flat_rate_amount && (
                  <div className="error-text">{validationErrors.flat_rate_amount}</div>
                )}
              </div>
              
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderTabContent = () => {
    const { contractTenureFrom, contractTenureTo } = CTData;

    if (activeTab === "toll") {
      return (
        <div className="tab-content">
          <div className="toll-from-to-date">
            <label className="input-label fs-14 fSemibold mb-10">
              From and To
            </label>
            <div className={Cx("", { "ht-400 wt-600": focusedInput })}>
              <DateRangePicker
                startDate={
                  dph_from_date
                    ? Moment(dph_from_date)
                    : contractTenureFrom
                    ? Moment(contractTenureFrom)
                    : null
                }
                startDateId="startDate"
                endDate={
                  dph_to_date
                    ? Moment(dph_to_date)
                    : contractTenureTo
                    ? Moment(contractTenureTo)
                    : null
                }
                endDateId="endDate"
                onDatesChange={handleDateChange}
                focusedInput={focusedInput}
                onFocusChange={onFocusChange}
                displayFormat={"DD MMM YYYY"}
                noBorder
                minimumNights={0}
                isOutsideRange={(day) => {
                  const from = Moment(contractTenureFrom);
                  const to = Moment(contractTenureTo);
                  return day.isBefore(from, "day") || day.isAfter(to, "day");
                }}
              />
            </div>
            {validationErrors?.dph_from_date && validationErrors?.dph_to_date && (
              <div className="error-text">{validationErrors.dph_from_date} {validationErrors?.dph_to_date}</div>
            )}
          </div>

          <div className="upload-section mt-20">
            {toll_tax_url ? (
              <div className="uploaded-file-name fs-14 mt-10 flex items-center">
                <span>File Uploaded:</span>
                <a
                  href={toll_tax_url}
                  target="_blank"
                  rel="noreferrer"
                  className="theme-color underline mr-10"
                >
                  {toll_tax_url.split("/").pop()}
                </a>
                <button
                  className="fs-13 text-red-600 underline no-border bg-transparent curP error-color"
                  onClick={() => handleRemoveUploadedFile("toll")}
                >
                  <MdDelete size={20} />
                </button>
              </div>
            ) : (
                <Upload onChange={(file) => uploadUpdateRate(file, "toll")}>
                <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-15 pr-20 mr-30">
                  Upload Toll Tax Doc
                </button>
              </Upload>
            )}
          </div>
          {validationErrors?.toll_tax_url && (
            <div className="error-text">{validationErrors.toll_tax_url}</div>
          )}

          <div className="toll-input-field-main mt-20">
            <div className="toll-input-denominator">
              <div className="input-group">
                <label className="input-label fs-14 fSemibold mb-5">
                  Toll Tax Inc/Dec Price
                </label>
                <Input
                  type="number"
                  placeholder="Enter Price"
                  name="toll_tax_price"
                  value={toll_tax_price}
                  onChange={handleInputChange}
                  // className="fs-14 no-border"
                  noTransition
                  className={Cx("fs-14 no-border", { "error-border": validationErrors?.toll_tax_price })}
                />
                {validationErrors?.toll_tax_price && (
                  <div className="error-text">{validationErrors?.toll_tax_price}</div>
                )}
              </div>
            </div>

            <div className="toll-input-denominator mt-15">
              <div className="input-group mr-15">
                <label className="input-label fs-14 fSemibold mb-5">
                  Denominator
                </label>
                <Input
                  type="number"
                  placeholder="Enter Denominator"
                  name="toll_tax_denominator"
                  value={toll_tax_denominator}
                  onChange={handleInputChange}
                  // className="fs-14 no-border"
                  noTransition
                  className={Cx("fs-14 no-border", { "error-border": validationErrors?.toll_tax_denominator })}
                />
                {validationErrors?.toll_tax_denominator && (
                  <div className="error-text">{validationErrors?.toll_tax_denominator}</div>
                )}
              </div>
             

              <div className="input-group">
                <label className="input-label fs-14 fSemibold mb-5">
                  Percentage
                </label>
                <Input
                  type="number"
                  placeholder="Enter Percentage"
                  name="toll_tax_percentage"
                  value={toll_tax_percentage}
                  onChange={handleInputChange}
                  // className="fs-14 no-border"
                  noTransition
                  className={Cx("fs-14 no-border", { "error-border": validationErrors?.toll_tax_percentage })}
                />
                {validationErrors?.toll_tax_percentage && (
                  <div className="error-text">{validationErrors.toll_tax_percentage}</div>
                )}
              </div>
            </div>
            {toll_tax_price && toll_tax_denominator && toll_tax_percentage && (
              <div className="calculated-value mt-10 fs-14 fSemibold">
                Toll Tax Updated Price:&nbsp;
                <span className="theme-color">
                  {Math.trunc(toll_tax_price / toll_tax_denominator) *
                    toll_tax_percentage}
                </span>
              </div>
            )}
          </div>
        </div>
      );
    }

    if (activeTab === "flat") {
      return renderFlatRateContent();
    }

    return <div className="tab-content"></div>;
  };

  const showBothTabs = is_rfq_toll_price_update && is_rfq_price_update;
  const user = getUser();
  const tollTaxApprovers = rfq?.toll_tax_approvers || [];
  const isApprover = tollTaxApprovers.includes(user.email);

  return (
    <Overlay>
      <div className="rfq-toll-container">
        <div className="rfq-header">RFQ Toll Updated Price</div>

        {showBothTabs ? (
          <div className="rfq-tabs">
            <div
              className={`rfq-tab ${activeTab === "toll" ? "active" : ""}`}
              onClick={() => setActiveTab("toll")}
            >
              Toll Tax Update Price
            </div>
            <div
              className={`rfq-tab ${activeTab === "flat" ? "active" : ""}`}
              onClick={() => setActiveTab("flat")}
            >
              Flat Rate
            </div>
          </div>
        ) : (
          <div className="single-tab-header">
            {is_rfq_toll_price_update && "Toll Tax Update Price"}
            {is_rfq_price_update && "Flat Rate"}
          </div>
        )}

        <div className="rfq-tab-body">{renderTabContent()}</div>

        <div className="rfq-footer">
          {isApprover ? (
            <button
              className="rfq-btn save"
              onClick={() =>
                onApproveTollTax("approve", {
                  toll_tax_price,
                  toll_tax_denominator,
                  toll_tax_percentage,
                  toll_tax_url,
                  dph_from_date,
                  dph_to_date,
                  flat_rate_percentage,
                  flat_rate_amount,
                  activeTab,
                  activeSubTab,
                  flat_percentage_url,
                  flat_amount_url,  
                })
              }
            >
              Approve
            </button>
          ) : (
            <button
              className="rfq-btn save"
              onClick={() =>
                onApproveTollTax("request", {
                  toll_tax_price,
                  toll_tax_denominator,
                  toll_tax_percentage,
                  toll_tax_url,
                  dph_from_date,
                  dph_to_date,
                  flat_rate_percentage,
                  flat_rate_amount,
                  activeTab,
                  activeSubTab,
                  flat_percentage_url,
                  flat_amount_url,  
                })
              }
            >
              Request
            </button>
          )}

          <button className="rfq-btn cancel" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </Overlay>
  );
};

export default RfqTollUpdatePrice;
